const TO_FDX = {
  underline: '</Text><Text Style="Underline">$2</Text><Text>',
  italic: '</Text><Text Style="Italic">$2</Text><Text>',
  bold: '</Text><Text Style="Bold">$2</Text><Text>',
  strikeout: '</Text><Text Style="Strikeout">$2</Text><Text>',
  bold_italic: '</Text><Text Style="Bold+Italic">$2</Text><Text>',
  italic_underline: '</Text><Text Style="Italic+Underline">$2</Text><Text>',
  bold_underline: '</Text><Text Style="Bold+Underline">$2</Text><Text>',
  bold_italic_underline: '</Text><Text Style="Bold+Italic+Underline">$2</Text><Text>',
  bold_strikeout: '</Text><Text Style="Bold+Strikeout">$2</Text><Text>',
  italic_strikeout: '</Text><Text Style="Italic+Strikeout">$2</Text><Text>',
  strikeout_underline: '</Text><Text Style="Strikeout+Underline">$2</Text><Text>',
  bold_italic_strikeout: '</Text><Text Style="Bold+Italic+Strikeout">$2</Text><Text>',
  bold_strikeout_underline: '</Text><Text Style="Bold+Strikeout+Underline">$2</Text><Text>',
  italic_strikeout_underline: '</Text><Text Style="Italic+Strikeout+Underline">$2</Text><Text>',
  bold_italic_strikeout_underline: '</Text><Text Style="Bold+Italic+Strikeout+Underline">$2</Text><Text>',
  ampersand: '&amp;',
  space: function (x) { return new Array(x.length + 1).join('&#x20;') },
  newline: '&#xA;',
  tab: '&#x9;'
}

const templates = {
  STRUCTURE_TO_HTML: {
    underline: '<span><u>$2</u></span>',
    italic: '<span><i>$2</i></span>',
    bold: '<span><b>$2</b></span>',
    bold_italic: '<span><b><i>$2</i></b></span>',
    italic_underline: '<span><i><u>$2</u></i></span>',
    bold_underline: '<span><b><u>$2</u></b></span>',
    bold_italic_underline: '<span><b><i><u>$2</u></i></b></span>',
    ampersand: '&amp;',
    space: function (x) { return new Array(x.length + 1).join('&nbsp;') },
    newline: '<br />',
    tab: '&nbsp;&nbsp;&nbsp;&nbsp;',
    url: '<span><a class="preview-link" href="$&">$&</a></span>',
    boneyard: '<span class="boneyard"></span>',
    diff: '<span class="diff">$1</span>',
    asterisk: '<span class="asterisk"></span>'
  },
  STRUCTURE_TO_FDX: TO_FDX,
  PROSE_TO_FDX: TO_FDX
}

module.exports = { templates }
